import React from 'react';

const RunningShoeLoader: React.FC<{ className?: string }> = ({ className = "w-16 h-16" }) => {
  return (
    <div className={`${className} relative inline-block`}>
      <style>{`
        @keyframes shoeFloat {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
        }

        @keyframes speedLine1 {
          0% {
            opacity: 0;
            transform: translateX(0px);
          }
          50% {
            opacity: 0.6;
          }
          100% {
            opacity: 0;
            transform: translateX(-25px);
          }
        }

        @keyframes speedLine2 {
          0% {
            opacity: 0;
            transform: translateX(0px);
          }
          50% {
            opacity: 0.6;
          }
          100% {
            opacity: 0;
            transform: translateX(-20px);
          }
        }

        @keyframes speedLine3 {
          0% {
            opacity: 0;
            transform: translateX(0px);
          }
          50% {
            opacity: 0.6;
          }
          100% {
            opacity: 0;
            transform: translateX(-15px);
          }
        }

        .shoe-main {
          animation: shoeFloat 0.8s ease-in-out infinite;
        }

        .speed-line-1 {
          animation: speedLine1 0.8s ease-out infinite;
        }

        .speed-line-2 {
          animation: speedLine2 0.8s ease-out infinite 0.15s;
        }

        .speed-line-3 {
          animation: speedLine3 0.8s ease-out infinite 0.3s;
        }
      `}</style>

      <svg
        viewBox="0 0 100 60"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Running Shoe (inspired by your logo) */}
        <g className="shoe-main">
          {/* Shadow */}
          <ellipse cx="55" cy="52" rx="20" ry="3" fill="#FF8C42" opacity="0.2"/>

          {/* Main Shoe Body - side profile */}
          <path
            d="M 35 35 Q 33 33 35 30 L 40 25 Q 45 22 52 22 L 65 22 Q 72 22 75 27 L 77 32 Q 78 35 75 38 L 70 42 Q 68 43 65 43 L 40 43 Q 37 43 35 40 Z"
            fill="#FF6B35"
            stroke="#FF8C42"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />

          {/* Toe area highlight */}
          <path
            d="M 40 28 Q 45 26 50 26 L 55 26 Q 58 26 58 29 Q 58 31 55 31 L 45 31 Q 42 31 40 28 Z"
            fill="#FF8C42"
            opacity="0.6"
          />

          {/* Swoosh-like accent */}
          <path
            d="M 45 33 Q 55 31 68 36"
            stroke="#FFFFFF"
            strokeWidth="2.5"
            strokeLinecap="round"
            fill="none"
            opacity="0.8"
          />

          {/* Sole */}
          <path
            d="M 37 43 L 70 43 Q 72 43 72 45 L 71 46 Q 70 47 68 47 L 38 47 Q 36 47 35 45 L 35 44 Q 35 43 37 43 Z"
            fill="#FF8C42"
          />

          {/* Heel detail */}
          <circle cx="72" cy="32" r="3" fill="#FFB84D"/>
        </g>

        {/* Speed Lines */}
        <g className="speed-line-1">
          <line x1="28" y1="28" x2="20" y2="28" stroke="#FF6B35" strokeWidth="2.5" strokeLinecap="round" opacity="0.7"/>
        </g>
        <g className="speed-line-2">
          <line x1="30" y1="35" x2="22" y2="35" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
        </g>
        <g className="speed-line-3">
          <line x1="32" y1="42" x2="26" y2="42" stroke="#FF6B35" strokeWidth="1.5" strokeLinecap="round" opacity="0.7"/>
        </g>
      </svg>
    </div>
  );
};

export default RunningShoeLoader;
